<script>
    import { mapActions, mapState } from "vuex";
    import { metaInfo } from "@/core/MetaInfo";
    import TypographyWrapper from "@/components/TypographyWrapper";

    export default {
        name: "DocumentConfidentiality",
        components: { TypographyWrapper },
        computed: {
            ...mapState("Root", {
                page: (state) => state.staticPage["document-confidentiality"],
            }),
            navigation() {
                const childrenHashes = [];
                return this.page.contentLeft
                    ?.map((item, index, array) => {
                        const title = item.desc;
                        const hash = item.title;
                        const children = array
                            .filter((child) => {
                                return child.title.startsWith(hash) && child.title !== hash;
                            })
                            .map((child) => {
                                childrenHashes.push(child.title);
                                return { title: child.desc, hash: child.title };
                            });

                        return { title, hash, children };
                    })
                    .filter((item) => !childrenHashes.includes(item.hash));
            },
        },
        serverPrefetch() {
            return this.getStaticPage({ slug: "document-confidentiality" });
        },
        mounted() {
            if (!this.page?.slug) {
                this.getStaticPage({ slug: "document-confidentiality" });
            }
        },
        methods: {
            ...mapActions("Root", ["getStaticPage"]),
            scrollTo(e) {
                e.preventDefault();
                if (e.currentTarget.hash) {
                    window.scrollTo({
                        top: document.querySelector(`${e.currentTarget.hash}`).offsetTop - 100,
                        behavior: "smooth",
                    });
                }
            },
        },
        metaInfo() {
            return metaInfo.getMeta("document-confidentiality");
        },
    };
</script>

<template>
    <div class="document-confidentiality">
        <div class="l-container">
            <typography-wrapper>
                <h2>Политика компании в&nbsp;отношении обработки персональных данных</h2>
                <div class="document-confidentiality__inner">
                    <div class="document-confidentiality__navigation">
                        <ol v-if="navigation">
                            <li v-for="(item, index) in navigation" :key="index">
                                <a :href="item.hash" @click="scrollTo">{{ item.title }}</a>
                                <ol v-if="item.children.length">
                                    <li
                                        v-for="(subItem, subIndex) in item.children"
                                        :key="subIndex"
                                    >
                                        <a :href="subItem.hash" @click="scrollTo">
                                            {{ subItem.title }}
                                        </a>
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </div>
                    <div
                        class="document-confidentiality__content"
                        v-html="page.contentRight"
                    ></div>
                </div>
            </typography-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
    .document-confidentiality {
        padding-bottom: 56px;
        h2 {
            max-width: 900px;
            text-align: center;
            margin-left: auto;
            margin-right: auto;
        }
    }

    .document-confidentiality__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
        }
    }

    .document-confidentiality__content {
        padding: 16px;
        background-color: var(--service-background-color);
        border: var(--service-border);
        border-radius: var(--service-border-radius);
        @include bp($bp-desktop-sm) {
            flex-grow: 1;
            padding: 32px;
        }
    }

    .document-confidentiality__navigation {
        margin-bottom: 24px;
        padding: 10px 16px 2px;
        background-color: var(--service-background-color);
        border: var(--service-border);
        border-radius: var(--service-border-radius);
        ol li {
            margin-top: 6px;
            margin-bottom: 0;
            font-size: 14px;
            line-height: 24px;
        }
        @include bp($bp-desktop-sm) {
            @include sticky(calc(var(--header-height) + 30px));
            order: 1;
            flex-shrink: 0;
            width: 100%;
            max-width: 460px;
            margin-bottom: 0;
            margin-left: 24px;
            padding: 26px 32px 12px;
            a {
                border-bottom: 1px solid transparent;
                transition: border-bottom-color 0.2s ease-in;
                &:hover {
                    border-bottom-color: var(--info-text--dark);
                }
            }
        }
    }
</style>
